import { http, HttpResponse } from "msw";
import { PlessService } from "src/app/shared/pless-service.model";

export const kymw1400Handlers = [
  http.post<unknown, { data: { parameter: { PageID: number; }; }; }>(
    PlessService.SERVICE.KYMW14getPage.url,
    async ({ request }) => {
      const pageId = (await request.json()).data.parameter.PageID;
      return HttpResponse.json(getPage(pageId));
    }
  ),
  http.post(
    PlessService.SERVICE.KYMW14getKomaMediumList.url,
    () => {
      return HttpResponse.json(getKomaMediumList);
    }
  )
];

const getPage = (pageId: number) => ({
  "status": "ok",
  "message": "処理完了",
  "result": {
    "obj": {
      "PageInfo": {
        "PageID": pageId,
        "PageNum": 1,
        "TemplateName": "食品（５×７）",
        "PositionX": 0.0,
        "PositionY": 0.0,
        "SizeW": 257.5,
        "SizeH": 350.0,
        "DivX": 5,
        "DivY": 7,
        "SectionInfo": [
          {
            "SectionID": 2553405,
            "PositionX": 0.0,
            "PositionY": 0.0,
            "SizeW": 1.0,
            "SizeH": 1.0,
            "DivX": 5,
            "DivY": 7,
            "KomaInfo": [
              {
                "KomaID": 43163917,
                "PositionX": 0.0,
                "PositionY": 0.0,
                "SizeW": 0.3,
                "SizeH": 0.214285714,
                "PromotionName": "ミ",
                "LayoutInfo": [
                  {
                    "MultiPublishString": "Ｗ親",
                    "OrderNumSeqNo": 10,
                    "Priority": 1,
                    "GuideGoodsName": "炭火やきとりもも串（しょうゆだれ）",
                    "GuideStandardName": "６本入（１６２ｇ）",
                    "MakerName": "ニチレイフレッシュ",
                    "ThisTimeSupplyPrice": 468,
                    "OrderNum": "001",
                    "PricePattern": "1",
                    "EdlpDiv": "0",
                    "ReceiptSOrderCode": "",
                    "StartOrderCode": "",
                    "OrderNum6Digits": "",
                    "ItemCode": "",
                    "OrderGoodsFlg": "02",
                    "PCode": "P2670878",
                    "OcrPublishFlg": '0'
                  }
                ],
                "ImageInfo": [
                  {
                    "ImagePath": "http://127.0.0.1:8083/N_PEACE/file/image//IMG_608/P2667277A_01.png?20250207135829",
                    "ShowSeq": 1
                  },
                  {
                    "ImagePath": "http://127.0.0.1:8083/N_PEACE/file/image//IMG_623/P2667277C_05.png?20250207135829",
                    "ShowSeq": 2
                  }
                ]
              },
              {
                "KomaID": 43163918,
                "PositionX": 0.3,
                "PositionY": 0.0,
                "SizeW": 0.3,
                "SizeH": 0.214285714,
                "PromotionName": "ミ",
                "LayoutInfo": [
                  {
                    "MultiPublishString": "Ｗ子",
                    "OrderNumSeqNo": 20,
                    "Priority": 1,
                    "GuideGoodsName": "炭火やきとりもも串（振り塩）",
                    "GuideStandardName": "６本入（１６２ｇ）",
                    "MakerName": "ニチレイフレッシュ",
                    "ThisTimeSupplyPrice": 468,
                    "OrderNum": "002",
                    "PricePattern": "1",
                    "EdlpDiv": "0",
                    "ReceiptSOrderCode": "",
                    "StartOrderCode": "",
                    "OrderNum6Digits": "",
                    "ItemCode": "",
                    "OrderGoodsFlg": "01",
                    "PCode": "P2667278",
                    "OcrPublishFlg": '1'
                  }
                ],
                "ImageInfo": [
                  {
                    "ImagePath": "http://127.0.0.1:8083/N_PEACE/file/image//IMG_608/P2667278A_01.png?20250207135829",
                    "ShowSeq": 1
                  }
                ]
              },
              {
                "KomaID": 43163919,
                "PositionX": 0.6,
                "PositionY": 0.0,
                "SizeW": 0.3,
                "SizeH": 0.214285714,
                "PromotionName": "ミ",
                "LayoutInfo": [
                  {
                    "MultiPublishString": "",
                    "OrderNumSeqNo": 30,
                    "Priority": 1,
                    "GuideGoodsName": "炭火やきとり皮串（しょうゆだれ）",
                    "GuideStandardName": "６本入（１６２ｇ）",
                    "MakerName": "ニチレイフレッシュ",
                    "ThisTimeSupplyPrice": 468,
                    "OrderNum": "003",
                    "PricePattern": "1",
                    "EdlpDiv": "0",
                    "ReceiptSOrderCode": "",
                    "StartOrderCode": "",
                    "OrderNum6Digits": "",
                    "ItemCode": "",
                    "OrderGoodsFlg": "01",
                    "PCode": "P2667281",
                    "OcrPublishFlg": '1'
                  }
                ],
                "ImageInfo": [
                  {
                    "ImagePath": "http://127.0.0.1:8083/N_PEACE/file/image//IMG_608/P2667281A_01.png?20250207135829",
                    "ShowSeq": 1
                  }
                ]
              },
              {
                "KomaID": 43163920,
                "PositionX": 0.0,
                "PositionY": 0.214285714,
                "SizeW": 0.3,
                "SizeH": 0.214285714,
                "PromotionName": "ミ",
                "LayoutInfo": [
                  {
                    "MultiPublishString": "",
                    "OrderNumSeqNo": 40,
                    "Priority": 1,
                    "GuideGoodsName": "炭火やきとり皮串（振り塩）",
                    "GuideStandardName": "６本入（１６２ｇ）",
                    "MakerName": "ニチレイフレッシュ",
                    "ThisTimeSupplyPrice": 468,
                    "OrderNum": "004",
                    "PricePattern": "1",
                    "EdlpDiv": "0",
                    "ReceiptSOrderCode": "",
                    "StartOrderCode": "",
                    "OrderNum6Digits": "",
                    "ItemCode": "",
                    "OrderGoodsFlg": "01",
                    "PCode": "P2667282",
                    "OcrPublishFlg": '0'
                  }
                ],
                "ImageInfo": [
                  {
                    "ImagePath": "http://127.0.0.1:8083/N_PEACE/file/image//IMG_608/P2667282A_01.png?20250207135829",
                    "ShowSeq": 1
                  }
                ]
              },
              {
                "KomaID": 43163921,
                "PositionX": 0.3,
                "PositionY": 0.214285714,
                "SizeW": 0.3,
                "SizeH": 0.214285714,
                "PromotionName": "ミ",
                "LayoutInfo": [
                  {
                    "MultiPublishString": "",
                    "OrderNumSeqNo": 50,
                    "Priority": 1,
                    "GuideGoodsName": "炭火やきとりレバー串（しょうゆだれ）",
                    "GuideStandardName": "５本入（１３５ｇ）",
                    "MakerName": "ニチレイフレッシュ",
                    "ThisTimeSupplyPrice": 468,
                    "OrderNum": "005",
                    "PricePattern": "1",
                    "EdlpDiv": "0",
                    "ReceiptSOrderCode": "",
                    "StartOrderCode": "",
                    "OrderNum6Digits": "",
                    "ItemCode": "",
                    "OrderGoodsFlg": "01",
                    "PCode": "P2667283",
                    "OcrPublishFlg": '0'
                  }
                ],
                "ImageInfo": [
                  {
                    "ImagePath": "http://127.0.0.1:8083/N_PEACE/file/image//IMG_608/P2667283A_01.png?20250207135829",
                    "ShowSeq": 1
                  }
                ]
              },
              {
                "KomaID": 43163922,
                "PositionX": 0.0,
                "PositionY": 0.642857143,
                "SizeW": 0.3,
                "SizeH": 0.214285714,
                "PromotionName": "",
                "LayoutInfo": [
                  {
                    "MultiPublishString": "Ｗ跨親",
                    "OrderNumSeqNo": 90,
                    "Priority": 1,
                    "GuideGoodsName": "スーパードライ缶（ケース）",
                    "GuideStandardName": "３５０ｍｌ×２４",
                    "MakerName": "アサヒ",
                    "ThisTimeSupplyPrice": 4168,
                    "OrderNum": "002000",
                    "PricePattern": "3",
                    "EdlpDiv": "0",
                    "ReceiptSOrderCode": "",
                    "StartOrderCode": "",
                    "OrderNum6Digits": "",
                    "ItemCode": "",
                    "OrderGoodsFlg": "01",
                    "PCode": "P2660157",
                    "OcrPublishFlg": '0'
                  }
                ],
                "ImageInfo": [
                  {
                    "ImagePath": "http://127.0.0.1:8083/N_PEACE/file/image//IMG_580/P2660157A_02.png?20250207135829",
                    "ShowSeq": 1
                  },
                  {
                    "ImagePath": "http://127.0.0.1:8083/N_PEACE/file/image//IMG_586/P2660157A_03.png?20250207135829",
                    "ShowSeq": 2
                  }
                ]
              },
              {
                "KomaID": 43163923,
                "PositionX": 0.3,
                "PositionY": 0.642857143,
                "SizeW": 0.3,
                "SizeH": 0.214285714,
                "PromotionName": "",
                "LayoutInfo": [
                  {
                    "MultiPublishString": "Ｗ親",
                    "OrderNumSeqNo": 100,
                    "Priority": 1,
                    "GuideGoodsName": "産直秋田あきたこまち",
                    "GuideStandardName": "５ｋｇ",
                    "MakerName": "ＪＡ秋田おばこ・秋田なまはげ産",
                    "ThisTimeSupplyPrice": 1480,
                    "OrderNum": "009",
                    "PricePattern": "2",
                    "EdlpDiv": "0",
                    "ReceiptSOrderCode": "",
                    "StartOrderCode": "",
                    "OrderNum6Digits": "",
                    "ItemCode": "",
                    "OrderGoodsFlg": "01",
                    "PCode": "P1390899",
                    "OcrPublishFlg": '0'
                  }
                ],
                "ImageInfo": [
                  {
                    "ImagePath": "http://127.0.0.1:8083/N_PEACE/file/image//IMG_369/P1390899A_08.png?20250207135829",
                    "ShowSeq": 1
                  },
                  {
                    "ImagePath": "http://127.0.0.1:8083/N_PEACE/file/image//IMG_608/P2667277C_02.png?20250207135829",
                    "ShowSeq": 2
                  }
                ]
              },
              {
                "KomaID": 43163924,
                "PositionX": 0.6,
                "PositionY": 0.642857143,
                "SizeW": 0.3,
                "SizeH": 0.214285714,
                "PromotionName": "",
                "LayoutInfo": [
                  {
                    "MultiPublishString": "Ｗ親",
                    "OrderNumSeqNo": 110,
                    "Priority": 1,
                    "GuideGoodsName": "無洗米産直秋田あきたこまち",
                    "GuideStandardName": "５ｋｇ",
                    "MakerName": "ＪＡ秋田おばこ・秋田なまはげ産",
                    "ThisTimeSupplyPrice": 1580,
                    "OrderNum": "010",
                    "PricePattern": "2",
                    "EdlpDiv": "0",
                    "ReceiptSOrderCode": "",
                    "StartOrderCode": "",
                    "OrderNum6Digits": "",
                    "ItemCode": "",
                    "OrderGoodsFlg": "01",
                    "PCode": "P1390937",
                    "OcrPublishFlg": '0'
                  }
                ],
                "ImageInfo": [
                  {
                    "ImagePath": "http://127.0.0.1:8083/N_PEACE/file/image//IMG_369/P1390937A_08.png?20250207135829",
                    "ShowSeq": 1
                  }
                ]
              },
              {
                "KomaID": 43163925,
                "PositionX": 0.3,
                "PositionY": 0.428571429,
                "SizeW": 0.3,
                "SizeH": 0.214285714,
                "PromotionName": "",
                "LayoutInfo": [
                  {
                    "MultiPublishString": "Ｗ跨親",
                    "OrderNumSeqNo": 70,
                    "Priority": 1,
                    "GuideGoodsName": "北海道のそのまま枝豆",
                    "GuideStandardName": "２５０ｇ",
                    "MakerName": "ジェイエイめむろフーズ",
                    "ThisTimeSupplyPrice": 258,
                    "OrderNum": "007",
                    "PricePattern": "2",
                    "EdlpDiv": "0",
                    "ReceiptSOrderCode": "",
                    "StartOrderCode": "",
                    "OrderNum6Digits": "",
                    "ItemCode": "",
                    "OrderGoodsFlg": "01",
                    "PCode": "P2539238",
                    "OcrPublishFlg": '1'
                  }
                ],
                "ImageInfo": [
                  {
                    "ImagePath": "http://127.0.0.1:8083/N_PEACE/file/image//IMG_304/P2539238A_03.png?20250207135829",
                    "ShowSeq": 1
                  },
                  {
                    "ImagePath": "http://127.0.0.1:8083/N_PEACE/file/image//IMG_199/P2539238C_02.png?20250207135829",
                    "ShowSeq": 2
                  }
                ]
              },
              {
                "KomaID": 43163926,
                "PositionX": 0.6,
                "PositionY": 0.428571429,
                "SizeW": 0.3,
                "SizeH": 0.214285714,
                "PromotionName": "",
                "LayoutInfo": [
                  {
                    "MultiPublishString": "",
                    "OrderNumSeqNo": 80,
                    "Priority": 1,
                    "GuideGoodsName": "徳用北海道のそのまま枝豆",
                    "GuideStandardName": "１ｋｇ",
                    "MakerName": "中札内村農業協同組合",
                    "ThisTimeSupplyPrice": 880,
                    "OrderNum": "008",
                    "PricePattern": "2",
                    "EdlpDiv": "1",
                    "ReceiptSOrderCode": "",
                    "StartOrderCode": "",
                    "OrderNum6Digits": "",
                    "ItemCode": "",
                    "OrderGoodsFlg": "01",
                    "PCode": "P2524478",
                    "OcrPublishFlg": '0'
                  }
                ],
                "ImageInfo": [
                  {
                    "ImagePath": "http://127.0.0.1:8083/N_PEACE/file/image//IMG_288/P2524478A_02.png?20250207135829",
                    "ShowSeq": 1
                  }
                ]
              },
              {
                "KomaID": 43163927,
                "PositionX": 0.0,
                "PositionY": 0.428571429,
                "SizeW": 0.3,
                "SizeH": 0.214285714,
                "PromotionName": "",
                "LayoutInfo": [
                  {
                    "MultiPublishString": "Ｗ跨子",
                    "OrderNumSeqNo": 60,
                    "Priority": 1,
                    "GuideGoodsName": "スコッティティシュフラワーボックス",
                    "GuideStandardName": "１６０Ｗ×５",
                    "MakerName": "日本製紙クレシア",
                    "ThisTimeSupplyPrice": 268,
                    "OrderNum": "006",
                    "PricePattern": "3",
                    "EdlpDiv": "0",
                    "ReceiptSOrderCode": "",
                    "StartOrderCode": "",
                    "OrderNum6Digits": "",
                    "ItemCode": "",
                    "OrderGoodsFlg": "01",
                    "PCode": "P2533781",
                    "OcrPublishFlg": '0'
                  }
                ],
                "ImageInfo": [
                  {
                    "ImagePath": "http://127.0.0.1:8083/N_PEACE/file/image//IMG_526/P2533781A_04.png?20250207135829",
                    "ShowSeq": 1
                  }
                ]
              }
            ]
          }
        ]
      }
    }
  }
});

const getKomaMediumList = {
  "status": "ok",
  "message": "処理完了",
  "result": {
    "obj": [
      {
        "MediumType": "001",
        "MediumName": "ハピデリ",
        "StopOrderCode": "9999999",
        "ProgressWorkNum": "",
        "ProgressWorkName": "",
        "ReceiptEOrderCode": "",
        "ReceiptECatalogId": "",
        "MediumTypeClass": "0",
        "DutiesFormDiv": "1"
      },
      {
        "MediumType": "003",
        "MediumName": "ぐるめぐり",
        "StopOrderCode": "9999999",
        "ProgressWorkNum": "",
        "ProgressWorkName": "",
        "ReceiptEOrderCode": "",
        "ReceiptECatalogId": "",
        "MediumTypeClass": "0",
        "DutiesFormDiv": "1"
      },
      {
        "MediumType": "004",
        "MediumName": "きらきらベビー",
        "StopOrderCode": "9999999",
        "ProgressWorkNum": "",
        "ProgressWorkName": "",
        "ReceiptEOrderCode": "",
        "ReceiptECatalogId": "",
        "MediumTypeClass": "0",
        "DutiesFormDiv": "1"
      },
      {
        "MediumType": "006",
        "MediumName": "らくらくコープデリ",
        "StopOrderCode": "9999999",
        "ProgressWorkNum": "",
        "ProgressWorkName": "",
        "ReceiptEOrderCode": "",
        "ReceiptECatalogId": "",
        "MediumTypeClass": "0",
        "DutiesFormDiv": "1"
      },
      {
        "MediumType": "007",
        "MediumName": "ライフスタイル",
        "StopOrderCode": "9999999",
        "ProgressWorkNum": "",
        "ProgressWorkName": "",
        "ReceiptEOrderCode": "",
        "ReceiptECatalogId": "",
        "MediumTypeClass": "0",
        "DutiesFormDiv": "1"
      },
      {
        "MediumType": "008",
        "MediumName": "別チラシ３",
        "StopOrderCode": "9999999",
        "ProgressWorkNum": "",
        "ProgressWorkName": "",
        "ReceiptEOrderCode": "",
        "ReceiptECatalogId": "",
        "MediumTypeClass": "0",
        "DutiesFormDiv": "1"
      },
      {
        "MediumType": "009",
        "MediumName": "別チラシ４",
        "StopOrderCode": "9999999",
        "ProgressWorkNum": "",
        "ProgressWorkName": "",
        "ReceiptEOrderCode": "",
        "ReceiptECatalogId": "",
        "MediumTypeClass": "0",
        "DutiesFormDiv": "1"
      },
      {
        "MediumType": "016",
        "MediumName": "からだの願い",
        "StopOrderCode": "9999999",
        "ProgressWorkNum": "",
        "ProgressWorkName": "",
        "ReceiptEOrderCode": "",
        "ReceiptECatalogId": "",
        "MediumTypeClass": "0",
        "DutiesFormDiv": "1"
      },
      {
        "MediumType": "018",
        "MediumName": "ＩＴ先着順",
        "StopOrderCode": "9999999",
        "ProgressWorkNum": "",
        "ProgressWorkName": "",
        "ReceiptEOrderCode": "",
        "ReceiptECatalogId": "",
        "MediumTypeClass": "0",
        "DutiesFormDiv": "1"
      },
      {
        "MediumType": "021",
        "MediumName": "プチハピ",
        "StopOrderCode": "9999999",
        "ProgressWorkNum": "",
        "ProgressWorkName": "",
        "ReceiptEOrderCode": "",
        "ReceiptECatalogId": "",
        "MediumTypeClass": "0",
        "DutiesFormDiv": "1"
      },
      {
        "MediumType": "023",
        "MediumName": "コスメｄｅきれい（ＣＤ）",
        "StopOrderCode": "9999999",
        "ProgressWorkNum": "",
        "ProgressWorkName": "",
        "ReceiptEOrderCode": "",
        "ReceiptECatalogId": "",
        "MediumTypeClass": "0",
        "DutiesFormDiv": "1"
      },
      {
        "MediumType": "025",
        "MediumName": "別チラシ６",
        "StopOrderCode": "9999999",
        "ProgressWorkNum": "",
        "ProgressWorkName": "",
        "ReceiptEOrderCode": "",
        "ReceiptECatalogId": "",
        "MediumTypeClass": "0",
        "DutiesFormDiv": "1"
      },
      {
        "MediumType": "026",
        "MediumName": "ｅフレンズ専用",
        "StopOrderCode": "9999999",
        "ProgressWorkNum": "",
        "ProgressWorkName": "",
        "ReceiptEOrderCode": "",
        "ReceiptECatalogId": "",
        "MediumTypeClass": "0",
        "DutiesFormDiv": "1"
      },
      {
        "MediumType": "029",
        "MediumName": "新発売",
        "StopOrderCode": "9999999",
        "ProgressWorkNum": "",
        "ProgressWorkName": "",
        "ReceiptEOrderCode": "",
        "ReceiptECatalogId": "",
        "MediumTypeClass": "0",
        "DutiesFormDiv": "1"
      },
      {
        "MediumType": "080",
        "MediumName": "ハピデリきらきら",
        "StopOrderCode": "9999999",
        "ProgressWorkNum": "",
        "ProgressWorkName": "",
        "ReceiptEOrderCode": "",
        "ReceiptECatalogId": "",
        "MediumTypeClass": "0",
        "DutiesFormDiv": "1"
      },
      {
        "MediumType": "081",
        "MediumName": "ヴィナチュール",
        "StopOrderCode": "9999999",
        "ProgressWorkNum": "",
        "ProgressWorkName": "",
        "ReceiptEOrderCode": "",
        "ReceiptECatalogId": "",
        "MediumTypeClass": "0",
        "DutiesFormDiv": "1"
      },
      {
        "MediumType": "090",
        "MediumName": "使用不可",
        "StopOrderCode": "9999999",
        "ProgressWorkNum": "",
        "ProgressWorkName": "",
        "ReceiptEOrderCode": "",
        "ReceiptECatalogId": "",
        "MediumTypeClass": "0",
        "DutiesFormDiv": "1"
      },
      {
        "MediumType": "403",
        "MediumName": "デイリー８Ｐチラシ",
        "StopOrderCode": "9999999",
        "ProgressWorkNum": "",
        "ProgressWorkName": "",
        "ReceiptEOrderCode": "",
        "ReceiptECatalogId": "",
        "MediumTypeClass": "0",
        "DutiesFormDiv": "2"
      },
      {
        "MediumType": "411",
        "MediumName": "スポット",
        "StopOrderCode": "9999999",
        "ProgressWorkNum": "",
        "ProgressWorkName": "",
        "ReceiptEOrderCode": "",
        "ReceiptECatalogId": "",
        "MediumTypeClass": "0",
        "DutiesFormDiv": "3"
      },
      {
        "MediumType": "XX1",
        "MediumName": "いつでも注文",
        "StopOrderCode": "9999999",
        "ProgressWorkNum": "",
        "ProgressWorkName": "",
        "ReceiptEOrderCode": "",
        "ReceiptECatalogId": "",
        "MediumTypeClass": "1",
        "DutiesFormDiv": "0"
      },
      {
        "MediumType": "XX2",
        "MediumName": "いつでも注文・法人",
        "StopOrderCode": "9999999",
        "ProgressWorkNum": "",
        "ProgressWorkName": "",
        "ReceiptEOrderCode": "",
        "ReceiptECatalogId": "",
        "MediumTypeClass": "1",
        "DutiesFormDiv": "0"
      },
      {
        "MediumType": "XX3",
        "MediumName": "ターゲット",
        "StopOrderCode": "9999999",
        "ProgressWorkNum": "",
        "ProgressWorkName": "",
        "ReceiptEOrderCode": "",
        "ReceiptECatalogId": "",
        "MediumTypeClass": "1",
        "DutiesFormDiv": "0"
      },
      {
        "MediumType": "XX4",
        "MediumName": "いきいきくらす",
        "StopOrderCode": "9999999",
        "ProgressWorkNum": "",
        "ProgressWorkName": "",
        "ReceiptEOrderCode": "",
        "ReceiptECatalogId": "",
        "MediumTypeClass": "1",
        "DutiesFormDiv": "0"
      },
      {
        "MediumType": "XX5",
        "MediumName": "いつでも注文・特別企画",
        "StopOrderCode": "9999999",
        "ProgressWorkNum": "",
        "ProgressWorkName": "",
        "ReceiptEOrderCode": "",
        "ReceiptECatalogId": "",
        "MediumTypeClass": "1",
        "DutiesFormDiv": "0"
      },
      {
        "MediumType": "XX6",
        "MediumName": "いつでも注文・お酒",
        "StopOrderCode": "9999999",
        "ProgressWorkNum": "",
        "ProgressWorkName": "",
        "ReceiptEOrderCode": "",
        "ReceiptECatalogId": "",
        "MediumTypeClass": "1",
        "DutiesFormDiv": "0"
      }
    ]
  }
};